<script setup>
import logoUrl from '../../img/centratel-logo.svg'

defineProps({
  location: { type: String, default: 'auth' },
})
</script>

<template>
  <img :src="logoUrl" alt="Centratel" class="block h-auto max-w-full dark:rounded-md dark:bg-white dark:p-2" :class="location === 'auth' ? 'w-56' : 'w-40'">
</template>
